export default __webpack_public_path__ + "static/media/repairserviceBG.28cec0c9.webp";